import {z} from 'zod';

import {messageSchema} from './MessageSchema';

/**
 * Schema for get message by ID response
 */
export const messageResponseSchema = messageSchema;

export type MessageResponse = z.infer<typeof messageResponseSchema>;
